import { Component } from '@angular/core';

@Component({
  selector: 'app-collapsable',
  templateUrl: './collapsable.component.html',
  styleUrl: './collapsable.component.scss'
})
export class CollapsableComponent {

}
